import { Component, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-edit-button',
  templateUrl: './edit-button.component.html',
  styleUrls: ['./edit-button.component.scss']
})
export class EditButtonComponent implements OnInit {

  @Output() onClick: Subject<void> = new Subject<void>()
  @Input() tooltipContent: string

  constructor() { }

  ngOnInit(): void {
  }

}
